import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import {labelDashboardBanner} from "./LabelDashboardMenu";


const useStyles = makeStyles((theme) => ({
    title: {
        flexGrow: 1,
    },
}));


export default function DashboardBanner(props) {

    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const bannerTitle = labelDashboardBanner.labelBanner[langPref];

    return (
        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            {bannerTitle}
        </Typography>
    );
}
